(function($){
    Drupal.behaviors.mo16 = {
        attach() {
            var openClass = 'MO16--open';
            var $timeout;

            $('.MO16__tags__button-js').off()
                .click(openTags)
                .keypress(openTags);

            $('.MO16__tags__close-js').off()
                .click(closeTags)
                .keypress(closeTags);

            function openTags(e) {
                if (e.which === 13 || e.type === 'click') {
                    const $element = $(this).closest('.MO16-js');
                    $element.addClass(openClass);
                    $element.find('.MO16__tags__button-js').attr('aria-expanded', 'true');
                    $timeout = setTimeout(function(){
                        $element.find('.MO16__tags__container-js').addClass('visible');
                        }, 400);
                }
            }

            function closeTags(e) {
                if (e.which === 13 || e.type === 'click') {
                    clearTimeout($timeout);
                    const $element = $(this).closest('.MO16-js');
                    $element.find('.MO16__tags__container-js').removeClass('visible');
                    $element.find('.MO16__tags__button-js').attr('aria-expanded', 'false');
                    $timeout = setTimeout(function(){
                        $element.removeClass(openClass);
                    }, 400);
                }
            }
        }
    };
})(jQuery);
